import yup from 'yup'

export default yup.object().shape({
  name: yup.string().required("Name can't be blank"),
  salesforce_id: yup.string().required("Salesforce ID can't be blank")
})



// WEBPACK FOOTER //
// ./src/validations/company.js